import React from "react";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  PUBLIC_PREFIX_PATH,
} from "configs/AppConfig";
import { definedPermissions } from "constants/PermissionConstant";
import PartnerLandingLayout from "views/auth-views/partner-landing/layout";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "terms-conditions",
    path: `${AUTH_PREFIX_PATH}/terms-conditions`,
    component: React.lazy(() => import("views/auth-views/terms-conditions")),
  },
  {
    key: "integration-partner-landing",
    path: "/partner-landing/:partnerId",
    component: PartnerLandingLayout,
    children: [
      {
        key: "integration-login",
        path: `login`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/login"),
        ),
      },
      {
        key: "integration-account",
        path: `account`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/account"),
        ),
      },
      {
        key: "integration-account-created",
        path: `account-created`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/account-created"),
        ),
      },
      {
        key: "integration-request-access",
        path: `request-access`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/request-access"),
        ),
      },
      {
        key: "integration-reset-password",
        path: `reset-password`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/reset-password"),
        ),
      },
      {
        key: "integration-user-setup",
        path: `user-setup/:userId`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/user-setup"),
        ),
      },
      {
        key: "integration-user-activated",
        path: `user-activated`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/user-activated"),
        ),
      },
      {
        key: "integration-request-sent",
        path: `request-sent`,
        component: React.lazy(
          () => import("views/auth-views/partner-landing/request-sent"),
        ),
      },
    ],
  },
  {
    key: "integration-not-found",
    path: `/partner-landing/not-found`,
    component: React.lazy(
      () => import("views/auth-views/partner-landing/partner-not-found"),
    ),
  },
  {
    key: "account",
    path: `${PUBLIC_PREFIX_PATH}/account`,
    component: React.lazy(() => import("views/public-views/account")),
  },
  {
    key: "account-created",
    path: `${PUBLIC_PREFIX_PATH}/account-created`,
    component: React.lazy(
      () => import("views/public-views/account/account-created"),
    ),
  },
  {
    key: "user-setup",
    path: `${PUBLIC_PREFIX_PATH}/user-setup/:userId`,
    component: React.lazy(
      () => import("views/public-views/account/user-setup"),
    ),
  },
  {
    key: "user-activated",
    path: `${PUBLIC_PREFIX_PATH}/user-activated`,
    component: React.lazy(
      () => import("views/public-views/account/user-activated"),
    ),
  },
  // {
  //   key: "login-callback",
  //   path: `${AUTH_PREFIX_PATH}/login-callback`,
  //   component: React.lazy(() =>
  //     import("views/auth-views/authentication/login-callback")
  //   ),
  // },
  // {
  //   key: "register",
  //   path: `${AUTH_PREFIX_PATH}/register`,
  //   component: React.lazy(() =>
  //     import("views/auth-views/authentication/register")
  //   ),
  // },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "order-tracking",
    path: `${PUBLIC_PREFIX_PATH}/order-tracking`,
    component: React.lazy(() => import("views/public-views/order-tracking")),
  },
  {
    key: "order-action",
    path: `${PUBLIC_PREFIX_PATH}/order-action/:salesOrderId/:revision`,
    component: React.lazy(() => import("views/public-views/order-action")),
  },
  {
    key: "maintenance",
    path: `${PUBLIC_PREFIX_PATH}/maintenance`,
    component: React.lazy(() => import("views/public-views/maintenance")),
  },
];

export const protectedRoutes = [
  // {
  //   key: "dashboard.default",
  //   path: `${APP_PREFIX_PATH}/dashboards/default`,
  //   component: React.lazy(() => import("views/app-views/dashboards/default")),
  // },
  {
    key: "orders",
    path: `${APP_PREFIX_PATH}/orders`,
    component: React.lazy(() => import("views/app-views/orders")),
    permissions: definedPermissions.ViewOrders,
  },
  {
    key: "orderDetails",
    path: `${APP_PREFIX_PATH}/order/details/:id`,
    component: React.lazy(() => import("views/app-views/pages/orderDetails")),
    breadcrumb: true,
    permissions: undefined,
  },
  {
    key: "customers",
    path: `${APP_PREFIX_PATH}/customers`,
    component: React.lazy(() => import("views/app-views/customers")),
    permissions: definedPermissions.ViewCustomers,
  },
  {
    key: "customerDetails",
    path: `${APP_PREFIX_PATH}/customer/details/:id`,
    component: React.lazy(
      () => import("views/app-views/pages/customerDetails"),
    ),
    breadcrumb: true,
    permissions: definedPermissions.ViewCustomerDetails,
  },
  {
    key: "users",
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import("views/app-views/users")),
    permissions: definedPermissions.ViewUsers,
  },
  {
    key: "admins",
    path: `${APP_PREFIX_PATH}/admins`,
    component: React.lazy(() => import("views/app-views/users/admin")),
    permissions: definedPermissions.ViewAdminUsers,
  },
  {
    key: "roles",
    path: `${APP_PREFIX_PATH}/roles`,
    component: React.lazy(() => import("views/app-views/roles")),
    permissions: definedPermissions.ViewRoles,
  },
  {
    key: "settings",
    path: `${APP_PREFIX_PATH}/settings/*`,
    component: React.lazy(() => import("views/app-views/settings")),
    breadcrumb: true,
    permissions: undefined,
  },
  {
    key: "terms-conditions",
    path: `${APP_PREFIX_PATH}/terms-conditions`,
    component: React.lazy(() => import("views/app-views/terms-conditions")),
    breadcrumb: true,
  },
  {
    key: "integration",
    path: `${APP_PREFIX_PATH}/integration`,
    component: React.lazy(() => import("views/app-views/integration")),
    breadcrumb: true,
    permissions: definedPermissions.ViewIntegrationDashboard,
  },
  {
    key: "vendor-orders",
    path: `${APP_PREFIX_PATH}/vendor/orders`,
    component: React.lazy(() => import("views/app-views/vendors/orders")),
    breadcrumb: true,
    permissions: definedPermissions.ViewVendorOrdersDashboard,
  },
  {
    key: "vendor-orderDetails",
    path: `${APP_PREFIX_PATH}/vendor/orderDetails/:id`,
    component: React.lazy(() => import("views/app-views/vendors/orderDetails")),
    breadcrumb: true,
    permissions: definedPermissions.ViewVendorOrdersDashboard,
  },
  {
    key: "actionRequired",
    path: `${APP_PREFIX_PATH}/vendor/index`,
    component: React.lazy(() => import("views/app-views/vendors/index")),
    breadcrumb: true,
    permissions: definedPermissions.AcceptRejectVendorOrders,
  },
  {
    key: "kitchen-dashboard",
    path: `${APP_PREFIX_PATH}/kitchen/index`,
    component: React.lazy(() => import("views/app-views/kitchen/index")),
    breadcrumb: true,
    permissions: definedPermissions.ViewKitchenOrdersDashboard,
  },
  {
    key: "kitchen-orders",
    path: `${APP_PREFIX_PATH}/kitchen/orders`,
    component: React.lazy(() => import("views/app-views/kitchen/orders")),
    breadcrumb: true,
    permissions: definedPermissions.ViewKitchenOrdersDashboard,
  },
  {
    key: "kitchen-reporting",
    path: `${APP_PREFIX_PATH}/kitchen/reporting`,
    component: React.lazy(() => import("views/app-views/kitchen/reporting")),
    breadcrumb: true,
    permissions: definedPermissions.ViewReporting,
  },
  {
    key: "kitchen-orderDetails",
    path: `${APP_PREFIX_PATH}/kitchen/orderDetails/:id`,
    component: React.lazy(() => import("views/app-views/kitchen/orderDetails")),
    breadcrumb: true,
    permissions: definedPermissions.ViewKitchenOrdersDashboard,
  },
  {
    key: "photos",
    path: `${APP_PREFIX_PATH}/photos`,
    component: React.lazy(() => import("views/app-views/photos")),
    breadcrumb: true,
    permissions: definedPermissions.ViewKitchenPhotos,
  },
  {
    key: "non-operational-vendors",
    path: `${APP_PREFIX_PATH}/non-operational-vendors`,
    component: React.lazy(
      () => import("views/app-views/non-operational-vendors"),
    ),
    breadcrumb: true,
  },
  {
    key: "iframe",
    path: `${APP_PREFIX_PATH}/iframe`,
    component: React.lazy(() => import("views/app-views/iframe")),
    breadcrumb: true,
  },
  {
    key: "admin-reporting",
    path: `${APP_PREFIX_PATH}/reporting`,
    component: React.lazy(() => import("views/app-views/reporting")),
    breadcrumb: true,
    permissions: definedPermissions.ViewAdminReporting,
  },
];
